import apiClient from "./axios.config";

const careerService = {
  submitCareerForm(payload) {
    return apiClient.post("/website/career", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default careerService;
